import { Divider, Typography } from '@mui/material'
import React from 'react'

const ChildrenPrivacy = () => {
  return (
    <>
    <Typography variant="h4" fontWeight="bold" gutterBottom>10. Children's Privacy</Typography>
    <Typography sx={{ fontSize: '1.1rem' }}>
        This App is <b>not intended for children under the age of 16</b>.
    </Typography>
     <Typography sx={{ fontSize: '1.1rem' }}>
        We do not knowingly collect data from minors. 
     </Typography>
      <Typography sx={{ fontSize: '1.1rem' }}>
       If such data is discovered, it will be promptly removed upon notification by a 
parent or legal guardian.
     </Typography>
     <Divider sx={{ my: 2 }} />
    </>

  )
}

export default ChildrenPrivacy